import {request} from '@/network/request'

// export function fetchList(query) {
//   return request({
//     url: '/gaoligong/animalgermplasm/page',
//     method: 'get',
//     params: query
//   })
// }
export function fetchList(data) {
  return request({
    url: '/gaoligong/animalgermplasmnew/getAnimalGermplasmNewList',
    method: 'post',
    data: data
  })
}

export function addObj(obj) {
  return request({
    url: '/gaoligong/animalgermplasm',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/gaoligong/animalgermplasm/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/gaoligong/animalgermplasm/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/gaoligong/animalgermplasm',
    method: 'put',
    data: obj
  })
}
